import { Message } from 'element-ui'; // 消息提示框组件 这个你们可以不用

// 新添加组件加验证（拖拽和点击添加是分别俩个地方）
export function verificationAddCommon (dataList, newComponent){

    // 只能唯一的组件列表（这些组件在整个页面中只能添加一次）
    const componentNameList = ['headerSerch', 'goodWaterfall', 'goodList'];

    // 检查新组件是否在唯一组件列表中
    if(componentNameList.includes(newComponent.name)){
        // 检查列表中是否已经存在相同名称的组件
        const existingComponent = dataList.find(item => item.name === newComponent.name);
        
        if(existingComponent){
            // 如果已存在，不允许添加
            Message({ 
                message: `${newComponent.title || newComponent.name} 组件只能添加一次`, 
                type: 'warning',
                duration: 2000
            });
            return false;
        }
    }

    // 互相冲突的组件列表
    // 格式：{ 组件名: [冲突的组件名数组] }
    // 例如：如果添加了 goodList，就不能添加 goodWaterfall
    const conflictComponents = {
        // 商品列表组件冲突：商品列表和商品瀑布流不能同时存在
        'goodList': ['goodWaterfall', 'promotionList'],
        'goodWaterfall': ['goodList', 'promotionList'],
        'promotionList': ['goodList', 'goodWaterfall'],
    };

    // 检查新组件是否与现有组件冲突
    if(conflictComponents[newComponent.name]){
        const conflictList = conflictComponents[newComponent.name];
        
        // 检查现有列表中是否存在冲突的组件
        const hasConflict = dataList.some(item => {
            return conflictList.includes(item.name);
        });
        
        if(hasConflict){
            // 找到冲突的组件
            const conflictComponent = dataList.find(item => conflictList.includes(item.name));
            const conflictName = conflictComponent ? (conflictComponent.title || conflictComponent.name) : conflictList[0];
            
            Message({ 
                message: `${newComponent.title || newComponent.name} 组件与 ${conflictName} 组件冲突，不能同时添加`, 
                type: 'warning',
                duration: 2000
            });
            return false;
        }
    }

    // 检查现有组件是否与新组件冲突（反向检查）
    // 遍历现有组件，检查它们的冲突列表是否包含新组件
    for(let i = 0; i < dataList.length; i++){
        const existingComponent = dataList[i];
        if(conflictComponents[existingComponent.name]){
            const conflictList = conflictComponents[existingComponent.name];
            if(conflictList.includes(newComponent.name)){
                Message({ 
                    message: `${newComponent.title || newComponent.name} 组件与已添加的 ${existingComponent.title || existingComponent.name} 组件冲突，不能同时添加`, 
                    type: 'warning',
                    duration: 2000
                });
                return false;
            }
        }
    }

    // 允许添加
    return true;
};